var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"topImgCtn"}),_c('div',{staticClass:"contentCtn"},[_c('div',{staticClass:"title"},[_vm._v("吉林一号在线访问产品使用协议")])])])
}]

export { render, staticRenderFns }